import { useNavigate } from 'react-router-dom';
import { useStore } from '../../store';
import { Button, ProgressBar, Slider, getAttractivenessLabel } from '../../components/ui';

export function SelfRatingScreen() {
  const navigate = useNavigate();
  const { onboarding, updateOnboarding, nextStep } = useStore();

  const handleChange = (value: number) => {
    updateOnboarding({ selfPerceivedAttractiveness: value });
  };

  const handleContinue = () => {
    nextStep();
    navigate('/onboarding/mission');
  };

  return (
    <div className="screen-container onboarding-screen">
      <ProgressBar current={5} total={17} className="mb-8" />

      <div className="flex-1 flex flex-col">
        <h1 className="text-3xl font-bold mb-2">How attractive do you see yourself?</h1>
        <p className="text-secondary mb-12">Be honest. This is just for you.</p>

        <div className="flex-1 flex flex-col justify-center">
          <Slider
            value={onboarding.selfPerceivedAttractiveness}
            min={1}
            max={10}
            onChange={handleChange}
          />

          <div className="text-center mt-8">
            <span className="text-2xl text-accent font-semibold">
              {getAttractivenessLabel(onboarding.selfPerceivedAttractiveness)}
            </span>
          </div>
        </div>
      </div>

      <Button onClick={handleContinue}>
        Continue
      </Button>
    </div>
  );
}
